
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.toggleMenu = function () {
  document.getElementById("mn").classList.toggle("open")
}
window.toggleSvc = function (h) {
  const item = h.closest(".svc"), open = item.classList.contains("open");
  document.querySelectorAll(".svc").forEach(s => s.classList.remove("open"));
  if (!open) item.classList.add("open");
}

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", () => {
  document.body.style.visibility = "visible";

  document.querySelectorAll('.motionTop').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 90%", // Start when element is 80% into view
        toggleActions: "play none none reverse"
      },
      duration: 2,
      y: 150,         // Move from 50px lower
      autoAlpha: 0,  // Fade in
      ease: "power3.out"
    });
  });

  document.querySelectorAll('.motionTopSeri').forEach((container) => {
    const offset = container.offsetLeft; // dynamic duration based on position

    gsap.from(container.children, {
      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        toggleActions: "play none none reverse"
      },
      duration: 2,
      y: 150,
      autoAlpha: 0,
      ease: "power3.out",
      stagger: 0.15 // <<< added to match motionStagger
    });
  });

  document.querySelectorAll('.motionDown').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "bottom 70%", // Start when element is 80% into view
        toggleActions: "play none none reverse"
      },
      duration: 2,
      y: -150,         // Move from 50px lower
      autoAlpha: 0,  // Fade in
      ease: "power3.out"
    });
  });

  document.querySelectorAll('.motionRight').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 70%", // Start when element is 80% into view
        toggleActions: "play none none reverse"
      },
      duration: 2,
      x: 150,         // Move from 50px lower
      autoAlpha: 0,  // Fade in
      ease: "power3.out"
    });
  });

  document.querySelectorAll('.motionLeft').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 70%", // Start when element is 80% into view
        toggleActions: "play none none reverse"
      },
      duration: 1,
      x: -150,         // Move from 50px lower
      autoAlpha: 0,  // Fade in
      ease: "power3.out"
    });
  });

  document.querySelectorAll('.motionStagger').forEach((container) => {
    gsap.from(container.children, {
      scrollTrigger: {
        trigger: container,
        start: "top 75%",
        toggleActions: "play none none reverse"
      },
      duration: 2,
      y: 50,
      autoAlpha: 0,
      ease: "power3.out",
      stagger: 0.15
    });
  });

  document.querySelectorAll('.motionBlurIn').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 75%",
        toggleActions: "play none none reverse"
      },
      duration: 2,
      autoAlpha: 0,
      y: 50,
      filter: "blur(10px)",
      ease: "power3.out",
      onUpdate: () => {
        gsap.to(element, { filter: "blur(0px)", duration: 1, overwrite: "auto" });
      }
    });
  });

  document.querySelectorAll('.motionZoomIn').forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 85%", // Slightly later trigger for better effect
        toggleActions: "play none none reverse"
      },
      duration: 2,
      scale: 0.4,        // Start smaller
      autoAlpha: 0,      // Fade in
      ease: "power3.out"
    });
  });

  document.querySelectorAll('.motionFlip').forEach((card) => {
    gsap.fromTo(
      card,
      {
        rotateY: 90,
        autoAlpha: 0,
        transformPerspective: 1000,
        transformOrigin: "center"
      },
      {
        scrollTrigger: {
          trigger: card,
          start: "top 80%",
          toggleActions: "play none none reverse"
        },
        duration: 1.5,
        rotateY: 0,
        autoAlpha: 1,
        ease: "power3.out"
      }
    );
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".slider-img");
  let current = 0;

  if (images.length > 0) {
    setInterval(() => {
      images[current].classList.remove("opacity-100");
      images[current].classList.add("opacity-0");

      current = (current + 1) % images.length;

      images[current].classList.remove("opacity-0");
      images[current].classList.add("opacity-100");
    }, 5000); // change every 5 seconds
  }

  const headings = document.querySelectorAll('.heading');
  headings.forEach(heading => {
    const line = document.createElement('span');
    line.className = 'w-12 h-[2px] bg-primary-yellowHard inline-block';
    const firstElement = heading.firstElementChild;

    if (firstElement) {
      heading.insertBefore(line, firstElement);
    } else {
      heading.appendChild(line);
    }
  });

  const headingCenters = document.querySelectorAll('.headingCenter');

  headingCenters.forEach(headingCenter => {
    const firstElement = headingCenter.firstElementChild;

    if (!firstElement) return;

    // line before
    const lineBefore = document.createElement('span');
    lineBefore.className = 'w-12 h-[2px] bg-primary-yellowHard inline-block';

    // line after
    const lineAfter = document.createElement('span');
    lineAfter.className = 'w-12 h-[2px] bg-primary-yellowHard inline-block';

    headingCenter.insertBefore(lineBefore, firstElement);
    headingCenter.insertBefore(lineAfter, firstElement.nextSibling);
  });


  (function () {
    const styleTitle = `
        color: #fff;
        background: #000;
      `;
    const styleSub = `
        color: #fff;
        background: #000;
      `;

    const c = console;
    c.log("%cDeveloped by Heinrich", styleTitle);
  })();

});
